module.exports = __webpack_public_path__ + "img/icon-up.ee2c2a8d.svg";